import { Component, OnInit, Input, OnChanges, signal, computed } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FlowObjectDefinition, FlowObjectInstance, FlowObjectInstanceState } from '../../../models/flow-object.model';
import { FlowDefinition, FlowInstance } from '../../../models/flow.model';
import { InputDataTaskFinish } from '../../../models/input-output-data.model';
import { Utils } from '../../../shared/utils';
import { IMPORTS } from './_imports';
import { Enums } from '../../../shared/enums';

@Component({
    selector: 'fob-finish',
    templateUrl: './fob-finish.component.html',
    styleUrl: './fob-finish.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class FlowObjectFinishComponent implements OnInit, OnChanges {
    // #region [Type props]
    FlowObjectInstanceState = FlowObjectInstanceState;
    Utils = Utils;
    Enums = Enums;
    // #endregion

    // #region [props]
    inputData: InputDataTaskFinish;
    forwardingProtocol = Enums.Messages.DefaultEmptyValue as string;
    processProtocol = Enums.Messages.DefaultEmptyValue as string;
    // #endregion

    // #region [signals]
    $model = signal(null as FlowObjectInstance);
    $flowObjectDefinition = signal(null as FlowObjectDefinition);
    $publicMessageHtml = signal(null as string);
    // #endregion

    // #region [computeds]
    $isPublicMessageHtmlLoading = computed(() => Utils.isNullOrEmpty(this.$publicMessageHtml()));
    // #endregion

    // #region [Input/Output]
    @Input() _model: FlowObjectInstance;
    @Input() _flowInstance: FlowInstance;
    @Input() _flowDefinition: FlowDefinition;
    // #endregion

    constructor(private cookieService: CookieService) { }

    ngOnInit() {
        Utils.setSignal(this.$flowObjectDefinition, this._flowDefinition.flowObjectDefinitions.find(x => x.id == this.$model().flowObjectDefinitionId));
        this.inputData = JSON.parse(this.$model().inputData) as InputDataTaskFinish;

        // #region [protocolo de Encaminhamento]
        this.forwardingProtocol = this._flowInstance.rootForwardingInfo;
        // #endregion

        // #region [protocolo de Processo]
        this.processProtocol = this._flowInstance.rootProcessInfo;
        // #endregion

        // #region [mensagem pública customizada]
        if (Utils.isNotNullOrEmpty(this.$flowObjectDefinition()?.publicMessageHtml)) {
            setTimeout(() => this.$publicMessageHtml.set(Utils.getParsedMessageHtml(
                this.cookieService,
                this.$flowObjectDefinition().publicMessageHtml,
                this.forwardingProtocol,
                this.processProtocol
            )), 1000);
            // #endregion
        }
    }

    ngOnChanges() {
        this.$model.set(this._model);
    }

    // #region [===== private methods =====]
    // #endregion
}
